var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "j-modal",
    {
      attrs: {
        title: _vm.title,
        width: _vm.width,
        visible: _vm.visible,
        switchFullscreen: "",
        okButtonProps: { class: { "jee-hidden": _vm.disableSubmit } },
        cancelText: _vm.language["common.closeButton"]
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel }
    },
    [
      _c(
        "a-spin",
        { attrs: { spinning: _vm.confirmLoading } },
        [
          _c(
            "j-form-container",
            [
              _c(
                "a-form-model",
                {
                  ref: "form",
                  attrs: {
                    slot: "detail",
                    model: _vm.model,
                    rules: _vm.validatorRules
                  },
                  slot: "detail"
                },
                [
                  _c(
                    "a-row",
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label:
                                  _vm.language["depart.management.departName"],
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                prop: "oldDepartId"
                              }
                            },
                            [
                              _c("a-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.model.departName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "departName", $$v)
                                  },
                                  expression: "model.departName"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label:
                                  _vm.language["depart.management.oldFDepart"],
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                prop: "oldDepartId"
                              }
                            },
                            [
                              _c("a-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.model.oldDepartName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "oldDepartName", $$v)
                                  },
                                  expression: "model.oldDepartName"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label:
                                  _vm.language[
                                    "depart.management.oldFDepartNo"
                                  ],
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                prop: "oldDepartId"
                              }
                            },
                            [
                              _c("a-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.model.oldDepartNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "oldDepartNo", $$v)
                                  },
                                  expression: "model.oldDepartNo"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label:
                                  _vm.language["depart.management.newFDepart"],
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                prop: "newDepartId"
                              }
                            },
                            [
                              _c("a-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.model.newDepartName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "newDepartName", $$v)
                                  },
                                  expression: "model.newDepartName"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label:
                                  _vm.language[
                                    "depart.management.newFDepartNo"
                                  ],
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                prop: "newDepartId"
                              }
                            },
                            [
                              _c("a-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.model.newDepartNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "newDepartNo", $$v)
                                  },
                                  expression: "model.newDepartNo"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: _vm.language["system.effectiveDate"],
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                prop: "effectiveDate"
                              }
                            },
                            [
                              _c("a-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: "",
                                  "disabled-date": _vm.disabledDate,
                                  disabled: _vm.model.status !== "1",
                                  valueFormat: "YYYY-MM-DD"
                                },
                                model: {
                                  value: _vm.model.effectiveDate,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "effectiveDate", $$v)
                                  },
                                  expression: "model.effectiveDate"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label:
                                  _vm.language["depart.moveBtn"] +
                                  _vm.language["common.status"],
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                prop: "status"
                              }
                            },
                            [
                              _c("j-dict-select-tag", {
                                attrs: {
                                  dictCode: "depart_move_status",
                                  disabled: ""
                                },
                                model: {
                                  value: _vm.model.status,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "status", $$v)
                                  },
                                  expression: "model.status"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }